import { render, staticRenderFns } from "./contactOrAbout.vue?vue&type=template&id=10999850&scoped=true&"
import script from "./contactOrAbout.vue?vue&type=script&lang=js&"
export * from "./contactOrAbout.vue?vue&type=script&lang=js&"
import style0 from "./contactOrAbout.vue?vue&type=style&index=0&id=10999850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10999850",
  null
  
)

export default component.exports